/**
 * SSR-safe cookie reader for attribution identifiers.
 */
export class CookieCollector {
  collectKnown(): Readonly<Record<string, string>> {
    if (typeof document === 'undefined') return {};

    const cookies = this.parseCookies();
    const result: Record<string, string> = {};

    const map: Record<string, string> = {
      _fbp: 'fbp',
      _fbc: 'fbc',
      _ga: 'ga',
      _gid: 'gid',
      _gcl_au: 'gclAu',
      _ttp: 'ttp',
      li_fat_id: 'liFatId',
      epik: 'epik',
    };

    for (const [cookieName, field] of Object.entries(map)) {
      const value = cookies[cookieName];
      if (value) result[field] = value;
    }

    return result;
  }

  private parseCookies(): Record<string, string> {
    if (typeof document === 'undefined') return {};

    try {
      return document.cookie.split(';').reduce(
        (acc, part) => {
          const [rawKey, ...rest] = part.trim().split('=');
          if (!rawKey) return acc;
          acc[rawKey] = decodeURIComponent(rest.join('=') || '');
          return acc;
        },
        {} as Record<string, string>
      );
    } catch {
      return {};
    }
  }
}
